<template>
  <div>
    <div class="payment-link-order">
      <el-form ref="form" :model="form" label-width="250px" label-position="left">
        <div class="title">{{ $t('payment_links.time_line') }}</div>
        <el-form-item :label="$t('payment_links.create_time')">
          <span class="content-text">{{ form.create_time || '-' }}</span>
        </el-form-item>
        <el-form-item :label="$t('payment_links.complete_time')">
          <span class="content-text">{{ form.complete_time || '-' }}</span>
        </el-form-item>

        <div class="title">{{ $t('payment_links.payment_breakdown') }}</div>
        <el-form-item :label="$t('payment_links.order_amount')">
          <span class="content-text">{{ form.order_amount | toDivideWithDot }}</span>
        </el-form-item>
        <el-form-item :label="$t('payment_links.transaction_fee')">
          <span v-if="form.fee_split" class="content-text">{{ form.fee_split | toDivideWithDot }}</span>
          <span v-else class="content-text">-</span>
        </el-form-item>
        <el-form-item :label="$t('payment_links.payment_amount')">
          <span v-if="form.payment_amount" class="content-text">{{ form.payment_amount | toDivideWithDot }}</span>
          <span v-else class="content-text">-</span>
        </el-form-item>

        <div class="title">{{ $t('payment_links.payment_description') }}</div>
        <el-form-item :label="$t('payment_links.checkout_order_id')">
          <span class="content-text">{{ form.checkout_id || '-' }}</span>
        </el-form-item>
        <el-form-item :label="$t('payment_links.merchant_order_id')">
          <span class="content-text">{{ form.merchant_order_id || '-' }}</span>
        </el-form-item>
        <el-form-item :label="$t('payment_links.payment_description')">
          <span class="content-text">{{ form.remark || '-' }}</span>
        </el-form-item>
        <el-form-item :label="$t('payment_links.customer_name')">
          <span class="content-text">{{ form.customer_name | strAesDecryptAndAsterisk }}</span>
        </el-form-item>
        <el-form-item :label="$t('payment_links.customer_email')">
          <span class="content-text">{{ form.email | strAesDecryptAndAsterisk }}</span>
        </el-form-item>
        <el-form-item :label="$t('payment_links.customer_mobile')">
          <span class="content-text">{{ form.mobile | strAesDecryptAndAsterisk }}</span>
        </el-form-item>
        <el-form-item :label="$t('payment_links.transaction_fee_charge_mode')">
          <span v-if="form.fee_split_type" class="content-text">{{ form.fee_split_type === FEE_SPLIT_TYPE.merchant ? $t('payment_links.transaction_fee_charge_mode1') : $t('payment_links.transaction_fee_charge_mode2') }}</span>
          <span v-else class="content-text">-</span>
        </el-form-item>

      </el-form>

    </div>
  </div>
</template>

<script>
import { payTransactionStatusMap } from '@/utils/maps'

export default {
  name: 'Transaction_Detail',
  props: {
    transactionData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    this.FEE_SPLIT_TYPE = {
      merchant: 1,
      customer: 2
    }
    return {
      tableData: [],
      form: {}
    }
  },
  computed: {
    getCheckoutOrderStatusMap() {
      return val => payTransactionStatusMap(val)
    }
  },
  watch: {
    transactionData(newVal) {
      this.form = newVal.payment_checkout_order
      this.tableData = newVal.transaction_list
      this.fieldInfoList = newVal.payment_link_checkout.field_info_list
    }
  }
}
</script>

<style lang = "scss" scoped>
.payment-link-order{
  .title{
    font-size: 16px;
    color: #000;
    font-weight: 600;
    padding: 24px 24px 12px;
    border-bottom: 1px solid #D3D7DF;
    margin-bottom: 12px;
  }
  .tableContainer{
    margin: 36px 24px 24px;
  }
  ::v-deep .el-form-item{
    padding-right: 24px;
    margin-bottom: 0;
    .el-form-item__label{
      padding-left: 24px;
      color: #1D3A71;
      font-family: Inter;
      font-weight: 600;
    }
    .content-text{
      color: #1D3A71;
      font-family: Inter;
      font-size: 12px;
      font-weight: 500;
    }
  }
  .tag-custom{
    border-radius: 28px;
    padding: 0 13px;
    height: 28px;
    line-height: 28px;
    border: none;
    vertical-align: middle;
    &.el-tag--info{
      color: #B45309;
      background-color: #FDE68A;
    }
    &.el-tag--success{
      color: #047857;
      background-color: #A7F3D0;
    }
    &.el-tag--danger{
      color: #71110E;
      background-color: #FCA5A5;
    }
  }
}
</style>

